import VueRouter from 'vue-router'
import RecordsTable from './views/RecordsTable.vue'
import UserDetails from './views/UserDetails.vue'

let routes = [
    {
        name: 'records_table',
        path: '/',
        component: RecordsTable
    }, {
        name: 'user.show',
        path: '/user/:user_id',
        component: UserDetails
    }
];

let router = new VueRouter({
    routes
});

export default router
